import { FC, useEffect } from 'react';
import { Skeleton } from 'antd';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { getMostUsedCategories } from 'src/store/mostUsedCategories/reducer';
import RequestCard from '../Card/RequestCard';

const RequestListEmpty: FC = () => {
  const mostUsedCategories = useSelector(
    (globalState: RootState) => globalState.mostUsedCategories
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMostUsedCategories());
  }, [dispatch]);

  return (
    <div className="space-y-10">
      <div>
        <p>You currently have no open requests. </p>

        <p>
          Get started by selecting a popular option below or{' '}
          <Link className="!underline" to="/requests/create">
            click here
          </Link>{' '}
          to view all request types.
        </p>
      </div>

      {mostUsedCategories.loading && !mostUsedCategories.categories.length ? (
        <div className="xl:pt-6 2xl:px-36">
          <Skeleton />
        </div>
      ) : (
        <>
          <div className="grid grid-flow-row auto-rows-[400px] gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:pt-6 2xl:px-24">
            {mostUsedCategories.categories.map(
              (request) =>
                !request.disabled && (
                  <RequestCard
                    key={request.id}
                    request={request}
                    renderButton={() => {
                      return (
                        <Link to={`/requests/create/${request.id}`}>
                          <span className="text-base font-semibold leading-none">
                            Create request
                          </span>
                          {request.timeEstimated && (
                            <span className="text-sm leading-none">
                              Starting {request.timeEstimated}
                            </span>
                          )}
                        </Link>
                      );
                    }}
                  />
                )
            )}
          </div>

          <div>
            <Link className="font-bold" to="/requests/create">
              View more
            </Link>
          </div>
        </>
      )}
    </div>
  );
};

export default RequestListEmpty;
